module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-12@2x-acd115d6c51480d4816f1971e41b82d9.png";